<div class="yellow-line" (click)="viewLastNote()"></div>
